import { ProjectsInformationFormFragment } from 'generated/resources/graphql'

export const getProjectsDefaultValues = (data?: ProjectsInformationFormFragment | null) => {
  return {
    projects: data?.projects || [],
  }
}
